import { render, staticRenderFns } from "./SQLIframeControl.vue?vue&type=template&id=05ccf21e&"
import script from "./SQLIframeControl.vue?vue&type=script&lang=ts&"
export * from "./SQLIframeControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports